// Zobrazení výpisu jprl podle prostorového dotazu
<template>
  <v-app-bar rounded="lg" absolute class="ma-1" dense extension-height="auto" style="z-index: 2" min-width="360">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-card v-bind="attrs" v-on="on" class="mx-1" color="transparent" flat width="200" v-if="true">
          <v-slider v-model="VypisZoom" class="align-center" max="120" min="50" step="1" thumb-color="accent2"
            hide-details dense>
            <template v-slot:append>
              <div v-text="VypisZoom + ' %'" class="text-no-wrap text-right mr-2" style="width: 40px"></div>
            </template>
          </v-slider>
        </v-card>
      </template>
      <span>Měřítko výpisu</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="VypisLight = !VypisLight" class="ml-4">
          <v-icon v-if="VypisLight" color="">mdi-sticker-text</v-icon>
          <v-icon v-else color="">mdi-sticker-text-outline</v-icon>
        </v-btn>
      </template>
      <span>Černobílý výpis</span>
    </v-tooltip>

    <v-speed-dial direction="right">
      <template v-slot:activator>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="ml-1">
              <v-icon color="">mdi-printer</v-icon></v-btn>
          </template>
          <span>Tisk vybrané jednotky</span>
        </v-tooltip>
      </template>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab small color="" @click="JprlPrint('printVypisLhpo_A4P')">
            <v-icon color="accent">mdi-crop-portrait</v-icon>
          </v-btn>
        </template>
        <span>Tisk A4 na výšku</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab small color="" @click="JprlPrint('printVypisLhpo_A4L')">
            <v-icon color="accent">mdi-crop-landscape</v-icon>
          </v-btn>
        </template>
        <span>Tisk A4 na šířku</span>
      </v-tooltip>
    </v-speed-dial>





    <v-spacer></v-spacer>

    <v-btn icon @click="VybCompClose()">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <template v-slot:extension>
      <v-card style="" v-if="true" rounded="lg" class="mt-1 pa-1" color="grey darken-4 ">
        <v-alert v-if="JprlVypisy.Dotazy == undefined || JprlVypisy.Dotazy.length < 1" class="text-body-2 ma-1"
          type="info" dense>Není vybrána žádná vrstva s daty lhpo.
        </v-alert>

        <div v-else>
          <div v-if="JprlVypisy.Dotazy.length > 1">
            <!-- Vybraný dotaz (mapová vrstva) - menu -->
            <v-tabs v-model="VybTabDotaz" show-arrows="">
              <v-tabs-slider color="accent2"></v-tabs-slider>
              <v-tab v-for="item in JprlVypisy.Dotazy" :key="item.Id">
                {{ item.Popis }}
              </v-tab>
            </v-tabs>

            <v-divider />
          </div>

          <!-- Vybraný dotaz (mapová vrstva) - výpis-->
          <v-tabs-items v-model="VybTabDotaz">
            <!-- Vybraný dotaz (mapová vrstva) - jednotlivé položky-->
            <v-tab-item v-for="(item, index) in JprlVypisy.Dotazy" :key="item.Id" ref="JprlVypisyDotazy">
              <v-card min-height="20" :loading="item.Loading">
              <!-- <div v-if="item.Loading" class="ma-2 text-center">
                  <v-progress-circular
                    indeterminate
                    color="accent"
                  ></v-progress-circular>
                    </div> -->

                <!-- Vybrané jprl - menu -->
                <v-tabs v-model="VybTabJprl[index]" v-if="item.Vypisy.length > 1">
                  <v-tab v-for="item2 in item.Vypisy" :key="item2.Jid">
                    <v-icon>mdi-book-open-variant</v-icon>
                  </v-tab>
                </v-tabs>

                <!-- Vybrané jprl - výpis -->
                <v-tabs-items v-model="VybTabJprl[index]" :light="VypisLight">
                  <v-alert v-if="!item.Loading && item.Vypisy.length < 1" class="text-body-2 ma-1" type="info" dense>
                    Tato vrstva neobsahuje ve vybraném výřezu žádné jprl.
                  </v-alert>

                  <!-- Vybrané jprl - jednotlivé položky-->
                  <v-tab-item v-for="item2 in item.Vypisy" :key="item2.Jid" class="JprlVypisyDotazyVypisy">
                    <div class="overflow-auto" :style="{
                      fontSize: (VypisZoom / 100) * 16 + 'px',
                    }" v-html="item2.Vypis" :class="VypisLight ? 'CB_VypisLhpo' : ''"></div>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>
    </template>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import ServiceLhpo from "../services/ServiceLhpo";
import print from "./common/print";

export default {
  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },
  data() {
    return {
      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      // Příklad dotazu z mapy - nepoužívá se
      // Při příchodu se doplní Loading a Vypisy
      JprlVypisyExample: {
        Bbox: {
          Epsg: "EPSG:3857",
          Xmin: 1638650.309,
          Ymin: 6479691.26,
          Xmax: 1638850.309,
          Ymax: 6479891.26,
        },
        Dotazy: [
          {
            Id: "islh_lhc_data", // jedinečný identifikátor
            Jid: "islh_lhc_data",
            SchvStav: true,
            Popis: "Datový sklad",
            // Loading: true,
            // Vypisy: ["vypis11", "vypis12", "vypis13"],
          },
          {
            Id: "islh_lhc_1rok",
            Jid: "islh_lhc_1rok",
            SchvStav: true,
            Popis: "První ročník",
            // Loading: false,
            // Vypisy: ["vypis21", "vypis22", "vypis23"],
          },
          {
            Id: "islh_lhc_data-100-101000",
            Jid: "islh_lhc_data-100-101000",
            SchvStav: true,
            Popis: "101000",
            // Loading: false,
            // Vypisy: ["vypis31", "vypis32", "vypis33"],
          },
        ],
      },
      // Vybraná tabulka query - přepínač
      VybTabDotaz: null,
      // Vybraná tabulka jprl - přepínač
      VybTabJprl: [],
      // Vlastní výpisy podle vzoru JprlVypisyExample
      JprlVypisy: [],
      // Měřítko výpisu
      VypisZoom: 100,
      // Černobílý výpis
      VypisLight: false,
      ERROR: null,
    };
  },

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Dotaz z mapy - z globální proměnně
    MapQueryJprl: function () {
      return this.$store.getters.GET_sMapQueryJprl;
    },
  },

  watch: {
    // Dotaz z mapy jprl - změna globální proměnné
    MapQueryJprl: function (value) {
      this.ZmenaMapQueryJprl(value);
    },
  },

  methods: {
    // Zavře tuto komponentu
    VybCompClose: function () {
      this.$store.commit("SET_sVybComp", {
        CompName: null,
        SlotName: this.CompList.find((item) => item.name == this.CompName).slot,
      });
    },

    ZmenaMapQueryJprl: function (value) {
      if (
        typeof value !== "undefined" &&
        value != null &&
        JSON.stringify(value) !== "{}"
      ) {
        // Klonování array
        this.JprlVypisy = JSON.parse(JSON.stringify(value));

        // Přepínače tabulek
        this.VybTabDotaz = 0;
        // Vybraná tabulka jprl - přepínač
        this.VybTabJprl = [];

        // Doplnění vlastností
        this.JprlVypisy.Dotazy.forEach((element) => {
          element.Loading = true;
          element.Vypisy = [];
        });
        // odstranění null
        if (this.JprlVypisy.Bbox.Xmin == null) {
          this.JprlVypisy.Bbox.Xmin = 0;
        }
        if (this.JprlVypisy.Bbox.Ymin == null) {
          this.JprlVypisy.Bbox.Ymin = 0;
        }
        if (this.JprlVypisy.Bbox.Xmax == null) {
          this.JprlVypisy.Bbox.Xmax = 0;
        }
        if (this.JprlVypisy.Bbox.Ymax == null) {
          this.JprlVypisy.Bbox.Ymax = 0;
        }
        // dotazy na výpisy
        this.JprlVypisy.Dotazy.forEach((element) => {
          this.NactiBboxJprl(
            element.Id,
            element.Jid,
            element.MajKod,
            this.JprlVypisy.Bbox.Epsg.slice(5),
            this.JprlVypisy.Bbox.Xmin,
            this.JprlVypisy.Bbox.Ymin,
            this.JprlVypisy.Bbox.Xmax,
            this.JprlVypisy.Bbox.Ymax,
            element.SchvStav
          );
        });
      }
    },

    // WS - Bbox Jprl
    NactiBboxJprl: function (
      Id,
      Jid,
      MajKod,
      EpsgCode,
      Xmin,
      Ymin,
      Xmax,
      Ymax,
      SchvStav
    ) {
      ServiceLhpo.BboxJprlMaj(
        Jid,
        MajKod,
        EpsgCode,
        Xmin,
        Ymin,
        Xmax,
        Ymax,
        SchvStav,
        true
      )
        .then((response) => {
          if (response.data.Dokonceno) {
            // Podívat se, jestli to odpovídá zadání - shodný výřez
            if (
              response.data.Zadani.Bbox.Xmin == this.JprlVypisy.Bbox.Xmin &&
              response.data.Zadani.Bbox.Ymin == this.JprlVypisy.Bbox.Ymin &&
              response.data.Zadani.Bbox.Xmax == this.JprlVypisy.Bbox.Xmax &&
              response.data.Zadani.Bbox.Ymax == this.JprlVypisy.Bbox.Ymax
            ) {
              // najít příslušný seznam podle Id

              // console.log("NactiBboxJprl response");
              // console.log("Id " + Id);
              // console.log("MajKod " + MajKod);

              var vVypisy = this.JprlVypisy.Dotazy.filter(
                (item) => item.Id == Id
              );

              if (
                typeof vVypisy !== "undefined" &&
                vVypisy != null &&
                vVypisy.length != null &&
                vVypisy.length > 0
              ) {
                // není prázdný seznam
                if (response.data.PocetJprl > 0) {
                  // console.log(response.data.SeznamJprl);
                  vVypisy[0].Vypisy = response.data.SeznamJprl;
                }
                // Vybraná tabulka jprl - přepínač
                this.VybTabJprl.push(0);
                vVypisy[0].Loading = false;
              }
            }
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //this.JprlVypisData = null;
        })
        .then(function () {
          // always executed
        });
    },

    // Tisk jprl
    JprlPrint: function (value) {
      //console.log(this.$refs.JprlVypisyDotazy[this.VybTabDotaz]);

      if (this.VybTabJprl.length > 0) {
        // console.log(
        //   this.$refs.JprlVypisyDotazy[
        //     this.VybTabDotaz
        //   ].$el.getElementsByClassName("JprlVypisyDotazyVypisy")[
        //     this.VybTabJprl[this.VybTabDotaz]
        //   ]
        // );

        //console.log(this.$refs.JprlVypisyDotazyVypisy);
        var VybEl = this.$refs.JprlVypisyDotazy[
          this.VybTabDotaz
        ].$el.getElementsByClassName("JprlVypisyDotazyVypisy")[
          this.VybTabJprl[this.VybTabDotaz]
        ];

        var _VypisLight = this.VypisLight;
        var _VypisZoom = this.VypisZoom;
        this.VypisLight = true;
        this.VypisZoom = 100;
        var _PrintName = this.JprlVypisy.Dotazy[this.VybTabDotaz].Popis;
        setTimeout(() => {
          print.PrintObj(VybEl, _PrintName, [value, "printVypisLhpo"]);
          this.VypisLight = _VypisLight;
          this.VypisZoom = _VypisZoom;
        }, 1000);
      }
    },
  },

  mounted() {
    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);
    // Jestli už není požadován výpis
    this.ZmenaMapQueryJprl(this.MapQueryJprl);

    // this.$store.commit("SET_sMapQueryJprl", this.JprlVypisyExample);
  },
};
</script>

<style >
@import "./common/VypisLhpo.css";
</style>